import { Alert, Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mappingKinds, type MappingKind } from '../../api/types';
import { kindLabelKeys } from '../mappings/mappingKinds';
import { CodelistVersionsSection } from './CodelistVersionsSection';

/**
 * The administrator's registry of standard code lists — a section of its own, apart from the
 * tenant-facing Mappings page and apart from Administration's tenants and accounts. These are not
 * the mappings: a release of standard codes is imported, reviewed and activated here, and every
 * tenant's mappings are then checked against it. The registry is shared, so the page needs no
 * tenant; a selected one only narrows whose affected mappings the reports show.
 */
export function CodelistsPage() {
  const { t } = useTranslation();
  const [kind, setKind] = useState<MappingKind>('Unit');

  return (
    <Stack spacing={2}>
      <Box>
        <Typography variant="h5">{t('codelists.title')}</Typography>
        <Typography variant="body2" color="text.secondary">
          {t('codelists.description')}
        </Typography>
      </Box>

      <Alert severity="info">{t('codelists.versions.note')}</Alert>

      <Tabs
        value={kind}
        onChange={(_event, value: MappingKind) => setKind(value)}
        variant="scrollable"
        scrollButtons="auto"
      >
        {mappingKinds.map((value) => (
          <Tab key={value} value={value} label={t(kindLabelKeys[value])} />
        ))}
      </Tabs>

      <CodelistVersionsSection kind={kind} />
    </Stack>
  );
}
